module.exports = __webpack_public_path__ + "js/0.d6368cf8.worker.js"